module.exports = __webpack_public_path__ + "img/zf_2@2x.49dceb59.png";